export function CocoLineAddIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width='24'
            height='25'
            viewBox='0 0 24 25'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}
        >
            <path
                d='M3.35288 9.45824C4.00437 6.68082 6.17301 4.51218 8.95043 3.86069C10.9563 3.39019 13.0437 3.39019 15.0496 3.86069C17.827 4.51218 19.9956 6.68082 20.6471 9.45825C21.1176 11.4641 21.1176 13.5516 20.6471 15.5574C19.9956 18.3348 17.827 20.5034 15.0496 21.1549C13.0437 21.6254 10.9563 21.6254 8.95044 21.1549C6.17301 20.5034 4.00437 18.3348 3.35288 15.5574C2.88237 13.5516 2.88237 11.4641 3.35288 9.45824Z'
                stroke='white'
            />
            <path
                d='M14.5 12.5078H9.5M12 15.0078L12 10.0078'
                stroke='white'
                stroke-linecap='round'
            />
        </svg>
    )
}
